/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ribbon__tabs{flex-grow:0;display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start;border:none}"];
export { styles as styles };
